import React, { useReducer, useEffect } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Currency } from '../lib/components/Currency';
import { WithApiAccess } from "../lib/HigherOrderComponents/WithApiAccess";
import { LoadingSpinner } from '../lib/components/LoadingSpinner';
import { FormattedDate } from '../lib/components/FormattedDate';
import { Pager } from '../lib/components/Pager';
import { withHeaderMessages } from '../higherOrderComponents/WithHeaderMessages';
import { PrinterFill } from 'react-bootstrap-icons'
import { ContractLayout } from './ContractLayout';
import qs from 'qs';

const ContractPaymentHistory = (props) => {

    const location = useLocation();
    const { page, pageSize, n, combined } = qs.parse(location.search, { ignoreQueryPrefix: true });

    const initialState = {
        makeRequest: true,
        isLoading: true,
        isLoadingPayments: true,
        contracts: [],
        contractsQueryString: n,
        contractNumbers: n.split(",") || [],
        paymentsAll: [],
        page: (page * 1) || 1,
        pageSize: (pageSize * 1) || 10,
        combined: combined || false
    }

    const reducer = (state, action) => {
        switch (action.type) {
            case 'contracts':
                return {
                    ...state,
                    contracts: action.payload,
                    isLoading: false
                }
            case 'isLoading':
                return {
                    ...state,
                    isLoading: action.payload
                }
            case 'page':
                return {
                    ...state,
                    page: action.payload
                }
            case 'pageSize':
                return {
                    ...state,
                    pageSize: action.payload
                }
            case 'paymentsAll':
                return {
                    ...state,
                    paymentsAll: action.payload
                }
            case 'isLoadingPayments':
                return {
                    ...state,
                    isLoadingPayments: action.payload
                }
            case 'hideLoader': 
                return {
                    ...state,
                    isLoading: false
                }
            case 'makeRequest': 
            return {
                ...state,
                makeRequest: false
            }
            default:
                throw new Error();
        }
    }

    const [paymentHistoryState, dispatch] = useReducer(reducer, initialState);
    const navigate = useNavigate();

    const pagingChangeHandler = (page, pageSize) => {
        const { contractsQueryString, combined } = paymentHistoryState
        dispatch({ type: 'page', payload: page })
        dispatch({ type: 'pageSize', payload: pageSize })
        navigate(location.pathname + qs.stringify({n: contractsQueryString, combined: combined, page: page, pageSize: pageSize}, { addQueryPrefix: true }));
        changePaging(page, pageSize);
    }

    function changePaging(page, pageSize) {
        let paging = {
            Options: {
                Page: (paymentHistoryState.contractNumbers.length > 1 || combined) ? 1 : page,
                ResultsPerPage: (paymentHistoryState.contractNumbers.length > 1 || combined) ? 2147483647 : pageSize
            }
        }
        let pagingQueryString = qs.stringify(paging, { allowDots: true, encode: false, addQueryPrefix: true });

        Promise.all(
            paymentHistoryState.contractNumbers.map(n => 
                props.api.get(`/api/contract/${n}/payment-history` + pagingQueryString)
                    .then(response => {
                        if (response.status === 200) { 
                            return response.data;
                        } else {
                            throw new Error('Api Error');
                        }
                    })
            )
        )
        .catch(() => dispatch({ type: 'isLoadingPayments', payload: false }))
        .then(data => {
            dispatch({ type: 'isLoadingPayments', payload: false });
            dispatch({ type: 'paymentsAll', payload: data });
        });
    }

    useEffect(() =>  
    {
        async function getContractDetails() {
            const { contractNumbers, combined } = paymentHistoryState;
            dispatch({ type: 'isLoading', payload: true });
            props.header.setHeader((contractNumbers.length > 1 || combined) ? "combinedDetails" : "contractDetails");
            
            await Promise.all(
                contractNumbers.map(n => 
                    props.api.get(`/api/contract/${n}`)
                        .then(response => {
                            if (response.status === 200) { 
                                return response.data;
                            }
                        })
                )
            )
            .catch(() => dispatch({ type: 'isLoading', payload: false }))
            .then(contracts => {
                contracts.sort((a, b) => a.number.localeCompare(b.number));
                dispatch({ type: 'contracts', payload: contracts})
            });
        }
        getContractDetails();
        changePaging(paymentHistoryState.page, paymentHistoryState.pageSize);

    }, [])

    const renderContract = (contract, i) => {
        const { paymentsAll, contractNumbers, contractsQueryString, combined } = paymentHistoryState;
        if (paymentHistoryState.isLoading || paymentHistoryState.isLoadingPayments) {
            return <LoadingSpinner />;
        }
        const paymentDetails = paymentsAll.find(p => p.contractNumber === contract.number);
        // console.log(paymentDetails)
        // !paymentDetails && console.log(`PaymentDetails is empty`)
        const recipientLabel = paymentDetails && paymentDetails.recipients && paymentDetails && paymentDetails.recipients.length > 1 ? 'Recipients' : 'Recipient';
        return (
            (!paymentDetails) ? 
                <div key={i}>
                    <LoadingSpinner />
                </div>
            :
            <ContractLayout key={i} queryString={contractsQueryString}
                contractNumber={contract.number} contractStatus={contract.status}
                isCombined={contractNumbers.length > 1 || combined} displayButtons={i === 0} label={"Contract " + contract.number}>
                {contract.providerNumber &&
                    <Row>
                        <Col sm={6}>
                            <span>Provider Contract Number: {contract.providerNumber}</span>
                        </Col>
                    </Row>
                }
                {paymentDetails && paymentDetails.purchaser &&
                    <Row>
                        <Col sm={6}>
                            <span>Purchaser: {paymentDetails.purchaser}</span>
                        </Col>
                    </Row>
                }
                {paymentDetails && paymentDetails.recipients && paymentDetails.recipients.length > 0 &&
                    <Row>
                        <Col sm={6}>
                            <span>{recipientLabel}: {paymentDetails.recipients.join(', ')}</span>
                        </Col>
                    </Row>
                }
                <Row>
                    <Col sm={6}>
                        <span>Total of All Payments: <Currency amount={paymentDetails && paymentDetails.totalPayments} /></span>
                    </Col>
                    {i === 0 &&
                        <Col sm={6} className='text-end'>
                            <Link
                                to={{
                                pathname:`/contract-payment-history-print?n=${contractsQueryString}`,
                                state: { contractNumber: contract.contractNumber, payments: paymentDetails.results }
                            }}>{ <PrinterFill /> }Printer friendly (All)</Link>
                        </Col>
                    }
                </Row>
                {paymentDetails && paymentDetails.results.length === 0
                    ?   <p>There are no payments for this contract.</p>
                    :   (<>

                            <Row>
                                <Col sm={12}>
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>Transaction Date</th>
                                                <th>Description</th>
                                                <th>Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {paymentDetails.results.map(p => (
                                                <tr key={p.posted + p.description}>
                                                    <td><FormattedDate date={p.posted} /></td>
                                                    <td>{p.description}</td>
                                                    <td><Currency amount={p.amount} /></td>
                                                </tr>
                                            ))}
                                            <tr>
                                                <td colSpan={2} style={{textAlign: "right"}}>Total</td>
                                                <td><Currency amount={paymentDetails.results.reduce((total, current) => total + current.amount, 0)} /></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </Col>
                            </Row>
                            {(contractNumbers.length === 1 && combined === false) &&
                                <Row>
                                    <Col sm={12}>
                                        <Pager 
                                            maxPages={paymentDetails.totalPages}
                                            maxItems={paymentDetails.totalRecords}
                                            pageSize={paymentHistoryState.pageSize}
                                            page={paymentHistoryState.page}
                                            onPageChange={pagingChangeHandler}
                                            onPageSizeChange={pagingChangeHandler} />
                                    </Col>
                                </Row>
                            }
                        </>
                )}
            </ContractLayout>
        )
    }

    const { contracts } = paymentHistoryState;
    if (paymentHistoryState.isLoading || paymentHistoryState.isLoadingPayments) {
        return <LoadingSpinner />;
    }

    return (
        (paymentHistoryState.isLoading || paymentHistoryState.isLoadingPayments) ?
        <div>
            <LoadingSpinner />
        </div>
        : 
        <div>
            {(contracts.length > 1) &&
            <Container>
                Jump To:&nbsp;
                {contracts.map((contract, i) => (
                    <span key={i}>
                        {(i > 0) && <span>, </span>}
                        <span style={{cursor: "pointer"}} onClick={() => document.getElementById(`cn${contract.number}`).scrollIntoView()}>{contract.number}</span>
                    </span>
                ))}
            </Container>}
            {contracts.map((contract, i) => (
                renderContract(contract, i)
            ))}
        </div>
    );
}

export default withHeaderMessages(WithApiAccess(ContractPaymentHistory));